import { render } from "./WorkloadRecommendingDialog.vue?vue&type=template&id=7e16e7a7&scoped=true"
import script from "./WorkloadRecommendingDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadRecommendingDialog.vue?vue&type=script&lang=js"

import "./WorkloadRecommendingDialog.vue?vue&type=style&index=0&id=7e16e7a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e16e7a7"]])

export default __exports__